<!--
 * @created on 2018/10/29
 * @author LaiXinYu <laixinyualex@gmail.com>
-->

<template>
    <div class="container">
        <div class="choose-travel-info">
            <div class="choose-input" @click="handleDestinationControl('on')">
                <div class="choose-label">目的地</div>
                <div :class="['choose-value',{active: form.addressId && form.addressStr}]">{{ form.addressId &&
                    form.addressStr ? form.addressStr : '请选择目的地'}}
                </div>
                <svg-icon icon-class="vertical-arrow" class-name="right-arrow"></svg-icon>
            </div>
            <div class="choose-input">
                <div class="choose-label">出行时间</div>
                <div class="choose-value">
                    <div :class="['time-item',{active:form.beginTime}]" @click="handleChooseDate(0)">
                        <template v-if="form.beginTime">
                            {{form.beginTime | dateFormat}}
                        </template>
                        <template v-else>请选择出行时间</template>
                    </div>
                    <div :class="['line',{active:form.beginTime && form.endTime}]">
                        <div class="distance-day" v-if="distanceDay">{{ distanceDay }}天</div>
                        <div class="line-bot">-</div>
                    </div>
                    <div :class="['time-item',{active:form.endTime}]" @click="handleChooseDate(1)">
                        <template v-if="form.endTime">
                            {{form.endTime | dateFormat}}
                        </template>
                        <template v-else>请选择结束时间</template>
                    </div>

                </div>
                <svg-icon icon-class="vertical-arrow" class-name="right-arrow"></svg-icon>
            </div>
        </div>

        <div class="compose-wrap" @click="handleComposeContentInput">
            <div class="compose-content">{{ decodeURIComponent(form.content ? form.content : '写下你精彩的旅游行程并简述约伴要求吧~') }}
            </div>
            <div class="content-num">{{ form.content && form.content.length ? form.content.length : 0}}/500</div>
        </div>

        <imageUpload @change="handleImgUploadChange" :images="form.imageArray"></imageUpload>

        <!-- 这里因为地址选择组件使用了click，这里用vue-touch会导致点击穿透，所以这里该用click -->
        <div class="choose-input position-choose-input" @click="handleChooseLocation">
            <svg-icon icon-class="position"></svg-icon>
            <div class="choose-label">{{ form.location ? form.location : '请选择所在城市'}}</div>
            <svg-icon icon-class="vertical-arrow" class-name="right-arrow"></svg-icon>
        </div>

        <div class="rule-check">
            <!-- 已勾选免责声明-->
            <div :class="['rule-check-btn',{'not-check':!agreeDisclaimer}]"
                 @click="agreeDisclaimer ? agreeDisclaimer = false : agreeDisclaimer = true">
                <div class="check-wrap">
                    <svg-icon icon-class="checkmark" class-name="checkmark"></svg-icon>
                </div>
                我已查看并接受
            </div>

            <div class="rule-router" @click="disclaimerOpen=true">免责声明</div>
        </div>

        <disclaimer :open="disclaimerOpen" @close="disclaimerOpen=false"></disclaimer>

        <!-- 目的地筛选项 -->
        <transition name="fade">
            <div class="fixed-wrap" v-show="destination.show">
                <div class="fixed-container">
                    <div class="fixed-label">目的地选择</div>

                    <div class="fixed-content">
                        <div class="destination">
                            <div class="options-nav">
                                <div @click="handleChooseDestinationArea('domestic')"
                                     :class="['nav-item', {'current':destination.currentArea === 'domestic'}]">
                                    国内
                                </div>
                                <div @click="handleChooseDestinationArea('foreign')"
                                     :class="['nav-item',{'current':destination.currentArea === 'foreign'}]">
                                    境外(含港澳台)
                                </div>
                            </div>
                            <div class="options-content">
                                <loading-ui
                                    v-if="destination.loading || !destination[destination.currentArea].length"></loading-ui>

                                <div class="option-wrap"
                                     v-else-if="destination[destination.currentArea].length">
                                    <div class="option-classify">
                                        <div
                                            @click="handleChooseDestinationClassify(index)"
                                            :class="['classify-item',{current:destination.currentClassify === index }]"
                                            v-for="(classify,index) in destination[destination.currentArea]"
                                            :key="classify.addressId"
                                        >
                                            {{ classify.name }}
                                        </div>
                                    </div>
                                    <div class="option-list">
                                        <div
                                            @click="handleChooseDestinationOption(index)"
                                            :class="['option-item',{'current': destination.currentOptionIndex === index}]"
                                            v-for="(option,index) in destination[destination.currentArea][destination.currentClassify].childList"
                                            :key="option.addressId"
                                        >
                                            {{ option.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="fixed-mask" @click="handleDestinationControl('')"></div>
                </div>
            </div>
        </transition>

        <text-input
            :open="textInputConfig.open"
            @cancel="handleTextInputCancel"
            @finish="handleTextInputFinish"
            title="编辑正文"
            placeholder="写下你精彩的旅游行程并简述约伴要求吧~"
            :limit="500"
            :value="form.content">
        </text-input>

        <date-picker
            v-model="datePicker.visible"
            type="date"
            ref="picker"
            :title="datePicker.currentChoose === 0  ? '请选择开始时间' : '请选择结束时间'"
            @confirm="handleDatePickerConfirm"
            @cancel="handleDatePickerCancel"
            :endDate="datePicker.endTime"
            :startDate="datePicker.startTime">
        </date-picker>

        <address-picker
            :visible="location.open"
            @hide="handleAddressPickerClose"
            @confirm="handleAddressPickerConfirm">
        </address-picker>

        <footer class="container-foot">
            <div :class="['submit-btn',{disable:!canSubmit}]" @click="handleSubmit">发布</div>
        </footer>
    </div>
</template>

<style scoped lang="scss">
@import "../../style/config";
@import "../../style/function";

.choose-travel-info {
    background: #fff;
    margin-bottom: px2rem(10);
}

.choose-input {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 px2rem(20);
    height: px2rem(110);
    color: #333;
    font-size: px2rem(28);
    border-bottom: px2rem(2) solid #e5e5e5;

    &:nth-last-of-type(1) {
        border-bottom: none;
    }

    .choose-label {
        min-width: 4em;
    }

    .choose-value {
        display: flex;
        align-items: center;
        flex: 1;
        color: #999;
        padding-left: px2rem(20);
        height: 100%;
    }

    .line {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 3em;
        font-size: px2rem(20);
        text-align: center;

        .line-bot {
            font-size: inherit;
        }
    }

    .time-item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        height: 100%;
        text-align: center;
    }

    .right-arrow {
        transform: rotate(180deg);
    }

    .active {
        color: #333;
    }
}

.compose-wrap {
    display: flex;
    flex-direction: column;
    background: #fff;
    height: px2rem(360);
    font-size: px2rem(28);
    margin-bottom: px2rem(10);
    padding: px2rem(20);
    box-sizing: border-box;
    overflow: hidden;
    color: #999;

    .compose-content {
        flex: 1;
        word-break: break-all;
        overflow-y: scroll;
        white-space: pre-wrap;
    }

    .content-num {
        text-align: right;
    }
}

.position-choose-input {
    background: #fff;
    margin-bottom: px2rem(32);

    .choose-label {
        flex: 1;
        padding-left: px2rem(10);
    }
}

.rule-check {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #717171;
    height: 1.5em;
    font-size: px2rem(24);

    .rule-router {
        color: #1f98fd;
    }

    .rule-check-btn {
        display: flex;

        &.not-check {
            .check-wrap:before {
                content: "";
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: #fff;
            }
        }
    }
}

.check-wrap {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: px2rem(24);
    height: px2rem(24);
    margin-right: px2rem(10);
    border-radius: px2rem(4);
    background: #fff;
    color: #fff;
    background: $btnColor;

    .checkmark {
        width: px2rem(16);
        height: px2rem(12);
    }
}

.container-foot {
    &:before {
        content: "";
        display: block;
        height: px2rem(100);
        margin-top: px2rem(20);
    }

    .submit-btn {
        position: fixed;
        width: 100%;
        height: px2rem(100);
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: $btnColor;
        color: #fff;
        font-size: px2rem(32);
        font-weight: bold;
        transition: background 0.2s ease;

        &.disable {
            background: #ccc;
            color: #fff;
        }
    }
}

.fixed-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;

    .fixed-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        /*
                                                这里原本是height:100%
                                                为了兼容ios-10.1.3 ios6
                                            */
        min-height: 100%;
        overflow: hidden;
        /* 兼容结束 */
    }

    .fixed-label {
        display: flex;
        justify-content: center;
        align-items: center;
        height: px2rem(88);
        color: #2e2e2e;
        font-size: px2rem(36);
        background: #fff;
    }

    .fixed-content {
        background: #fff;
    }

    .fixed-mask {
        flex: 1;
        background: rgba(0, 0, 0, 0.5);
    }
    // 目的地
    .destination {
        display: flex;
        flex-direction: column;

        .options-nav {
            display: flex;
            align-items: center;
            height: px2rem(92);
            box-sizing: border-box;
            padding: 0 px2rem(32);
            color: $secondaryColor;
            font-weight: bold;
            box-shadow: rgba(0, 0, 0, 0.1) 0 px2rem(1) px2rem(2) 0;
        }

        .current {
            color: $btnColor;
        }

        .nav-item {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 px2rem(24);
            height: 100%;

            &.current {
                color: $btnColor;

                &:before {
                    content: "";
                    bottom: 0;
                    left: 50%;
                    position: absolute;
                    width: px2rem(32);
                    height: px2rem(6);
                    background: $btnColor;
                    transform: translate(-50%, 0);
                }
            }
        }

        .option-wrap {
            display: flex;
            max-height: 7rem;

            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
        }

        .option-classify {
            width: px2rem(244);
            overflow-x: hidden;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
        }

        .classify-item {
            display: flex;
            justify-content: center;
            align-items: center;
            height: px2rem(100);
            font-weight: bold;

            &.current {
                position: relative;

                &:before {
                    content: "";
                    position: absolute;
                    width: px2rem(18);
                    height: px2rem(18);
                    top: 50%;
                    right: 0;
                    background: $baseBackgroundColor;
                    transform: translate(50%, -50%) rotate(45deg);
                    z-index: 6;
                }
            }
        }

        .option-list {
            flex: 1;
            background: $baseBackgroundColor;
            max-height: 10rem;
            overflow-y: auto;
            overflow-scrolling: touch;
        }

        .option-item {
            display: flex;
            justify-content: center;
            align-items: center;
            height: px2rem(100);
            font-weight: bold;
            box-sizing: border-box;
            border-bottom: px2rem(2) solid #e5e5e5;
        }
    }
}
</style>

<script>
import { getAddressList } from "../../api/common";
import Service from "../../api/topic";

import TextInput from "../../components/textInput/index";
import LoadingUi from "../../components/LoadingUI/index";
import AddressPicker from "../../components/AddressPicker/index";
import DatePicker from "../../components/DatePicker/index";
import Disclaimer from "./Disclaimer";
import ImageUpload from "./ImageUpload";

import { replaceWrap } from "../../utils/util";

import {
    goBack as nativeGoBack,
    onVisibilityChange
} from "../../nativeApi/index";

export default {
    name: "Compose",
    components: {
        TextInput,
        LoadingUi,
        AddressPicker,
        DatePicker,
        Disclaimer,
        ImageUpload
    },
    data() {
        return {
            disclaimerOpen: false, // 查看免责声明
            agreeDisclaimer: true, //是否已同意免责声明
            imgUploading: false, // 是否有图片正在上传中
            datePicker: {
                visible: null,
                startTime: new Date(),
                endTime: new Date(new Date().getFullYear() + 10, 11, 31),
                currentChoose: 0 // 0 出发日期选择， 1 结束日期选择
            },
            form: {
                addressId: null,
                addressStr: null,
                beginTime: "",
                content: null,
                endTime: "",
                imageArray: [],
                location: null
            },

            textInputConfig: {
                open: false,
                value: null,
                lastInputStatus: null // 最后一次输入的返回情况 cancel/finish
            },
            destination: {
                show: false,
                currentArea: "domestic", // 当前显示区域
                currentClassify: 0, // 当前左侧链接
                loading: false,
                currentOptionIndex: -1,
                // 国内地点
                domestic: [],
                // 国外地点
                foreign: []
            },

            location: {
                open: false
            }
        };
    },
    computed: {
        canSubmit() {
            console.log("canSubmit");
            return (
                !!this.form.addressId &&
                !!this.form.addressStr &&
                !!this.form.beginTime &&
                !!this.form.content &&
                !!this.form.endTime &&
                this.agreeDisclaimer
            );
        },
        distanceDay() {
            if (this.form.endTime && this.form.beginTime) {
                return (
                    Math.ceil(
                        (this.form.endTime - this.form.beginTime) /
                            (24 * 3600 * 1000)
                    ) + 1
                );
            } else {
                return "";
            }
        },

        // 填写了任何东西都需要弹出挽留提示
        needRetainTips() {
            return (
                this.form.addressId ||
                this.form.addressStr ||
                this.form.beginTime ||
                this.form.content ||
                this.form.endTime ||
                this.form.location ||
                this.form.imageArray.length
            );
        },

        // 判断是否绑定手机
        hasPhone() {
            return !!this.$store.getters.userInfo.phone;
        }
    },

    beforeRouteEnter(to, form, next) {
        next(vm => {
            if (!vm.hasPhone) {
                console.log("没有手机号");
                vm.showBindPhone(vm);
            }
        });
    },

    mounted() {
        if (this.$env.isTravelCatApp) {
            onVisibilityChange(visibile => {
                console.log("native call : onVisibilityChange");
                if (visibile) {
                    if (!this.hasPhone) {
                        console.log("没有手机号");
                        this.showBindPhone(this);
                    }
                }
            });
        }
    },

    beforeRouteLeave(to, from, next) {
        // 如果非提交成功且有已输入内容，则出现挽留页面
        if (to.name !== "composeSuccess") {
            if (!this.needRetainTips) {
                next();
            } else {
                this.$messageBox({
                    title: "返回后已编辑内容不会被保留,确认返回吗？",
                    buttonList: ["狠心离开", "继续编辑"]
                }).then(res => {
                    if (res === 0) {
                        next();
                    } else {
                        next(false);
                    }
                });
            }
        } else {
            next();
        }
    },
    methods: {
        replaceWrap,
        // 选择目的地
        handleDestinationControl(type = "on") {
            if (type === "on") {
                // 如果类型为打开

                this.destination.show = true;

                const thisDestination = this.destination;
                const { currentArea } = thisDestination;

                // 需要判断国内或国外数据有没有加载
                if (
                    !thisDestination[currentArea] ||
                    !thisDestination[currentArea].length
                ) {
                    this.pullDestinationOptions(currentArea);
                }
            } else {
                this.destination.show = false;
            }
        },

        showBindPhone(context) {
            context
                .$messageBox({
                    title: "请先绑定手机号码",
                    buttonList: ["再看看", "去绑定"]
                })
                .then(res => {
                    if (res === 1) {
                        context.$router.replace({ name: "bindPhone" });
                    } else {
                        // 停留在原页面
                        if (context.$env.isTravelCatApp) {
                            nativeGoBack();
                        } else {
                            context.$router.back();
                        }
                    }
                });
        },

        async pullDestinationOptions(destinationType) {
            this.destination.loading = true;

            // 拉取目的地选项
            let { code, data, msg } = await getAddressList({
                type: destinationType === "domestic" ? 0 : 1
            });

            if (code === 200) {
                this.destination[destinationType] = data;
            } else {
                this.$toast.open({ msg });
            }

            this.destination.loading = false;
        },

        async handleChooseDestinationArea(newArea) {
            let { destination } = this;

            if (destination.currentArea === newArea) return;

            destination.currentArea = newArea;

            // 暂时在切换区域时把已选的目的地重置
            destination.currentClassify = 0;
            // destination.currentOptionIndex = 0;

            // 目的地因为国内/国外的选项是分别加载的，所以要先判断有无加载该地区数据
            let currentAreaData = destination[newArea];

            if (!currentAreaData || currentAreaData.length <= 0) {
                await this.pullDestinationOptions(newArea);

                destination = this.destination;
                currentAreaData = destination[newArea];
            }
            // 原本会帮他自动选择第一个，现在去掉
            //
            // const currentAddressOption =
            //     currentAreaData[destination.currentClassify].childList[
            //         destination.currentOptionIndex
            //     ];
            //
            // this.form.addressId = currentAddressOption.addressId;
            // this.form.addressStr = currentAddressOption.name;
        },

        handleChooseDestinationClassify(newClassifyIndex) {
            let { destination } = this;

            if (destination.currentClassify === newClassifyIndex) return;

            destination.currentClassify = newClassifyIndex;

            // 更换目的地分类后需重置所选
            destination.currentOptionIndex = -1;
            // 原本会帮他自动选择第一个，现在去掉
            //
            // const currentAddressOption =
            //     destination[destination.currentArea][
            //         destination.currentClassify
            //     ].childList[destination.currentOptionIndex];
            //
            // this.form.addressId = currentAddressOption.addressId;
            // this.form.addressStr = currentAddressOption.name;
        },

        handleChooseDestinationOption(newOptionIndex) {
            let { destination } = this;

            destination.currentOptionIndex = newOptionIndex;

            const currentAddressOption =
                destination[destination.currentArea][
                    destination.currentClassify
                ].childList[destination.currentOptionIndex];

            this.form.addressId = currentAddressOption.addressId;
            this.form.addressStr = currentAddressOption.name;

            this.handleDestinationControl("off");
        },

        async handleComposeContentInput() {
            this.showTextInput();

            const value = await this.getTextInputValue();

            if (this.textInputConfig.lastInputStatus === "finish") {
                this.form.content = decodeURIComponent(value);
            }
        },

        getTextInputValue() {
            return new Promise(resolve => {
                const unwatch = this.$watch(
                    "textInputConfig",
                    n => {
                        // 先缓存value
                        const { value } = n;

                        resolve(value);

                        // 结束监听
                        unwatch();

                        // 重置value
                        this.textInputConfig.value = "";
                    },
                    {
                        deep: true
                    }
                );
            });
        },

        showTextInput() {
            this.textInputConfig.open = true;
        },

        hideTextInput() {
            this.textInputConfig.open = false;
        },

        // 输入框关闭事件
        handleTextInputCancel() {
            this.textInputConfig.lastInputStatus = "cancel";

            this.hideTextInput();
        },

        // 输入框完成输入事件
        handleTextInputFinish(e) {
            this.textInputConfig.lastInputStatus = "finish";

            this.textInputConfig.value = e.value;

            this.hideTextInput();
        },

        // 选择定位
        handleChooseLocation() {
            console.log("handleChooseLocation");

            this.location.open = true;
        },

        handleAddressPickerClose(detail) {
            console.log(detail);

            this.location.open = false;
        },

        handleAddressPickerConfirm(detail) {
            let newLocation = "";

            detail.forEach(address => {
                newLocation += `${address.label} `;
            });

            this.form.location = newLocation;
        },

        // 选择出发时间
        handleChooseDate(current) {
            this.datePicker.currentChoose = current;

            if (current === 1 && this.form.beginTime) {
                this.datePicker.startTime =
                    new Date(this.form.beginTime) || new Date();

                // 重置endTime
                this.datePicker.endTime = new Date(
                    new Date().getFullYear() + 10,
                    11,
                    31
                );
            } else {
                this.datePicker.startTime = new Date();

                if (this.form.endTime) {
                    this.datePicker.endTime = new Date(this.form.endTime);
                }
            }

            this.$refs.picker.open();
        },

        handleDatePickerConfirm(date) {
            const timestamp = new Date(date).getTime();

            if (this.datePicker.currentChoose === 0) {
                // 新选择开始时间大于结束时间情况
                if (this.form.endTime && timestamp > this.form.endTime) {
                    this.form.beginTime = this.form.endTime;

                    this.$toast.open({ msg: "开始时间不可大于结束时间！" });
                } else {
                    this.form.beginTime = timestamp;
                }
            } else {
                this.form.endTime = timestamp;
            }
        },

        handleDatePickerCancel() {
            console.log("cancel");
        },

        async handleSubmit() {
            if (!this.canSubmit) {
                return;
            }

            if (this.imgUploading) {
                this.$toast.open({ msg: "图片正在上传，请稍后再发布" });
                return;
            }

            if (this.handleSubmit.submiting) return;

            this.handleSubmit.submiting = true;

            const { code, msg } = await Service.releaseTopic(this.form);

            if (code === 200) {
                if (this.$env.isTravelCatApp) {
                    this.$router.push({
                        name: "composeSuccess"
                    });

                    nativeGoBack({
                        animated: false,
                        direct: false
                    });
                } else {
                    this.$router.replace({
                        name: "composeSuccess"
                    });
                }
            } else {
                this.handleSubmit.submiting = false;

                this.$toast.open({ msg });
            }
        },

        handleImgUploadChange({ images }) {
            const newImgList = [];
            console.log("change");
            images.forEach(img => {
                this.imgUploading = img.status === 0;

                newImgList.push(img.src);
            });

            this.form.imageArray = newImgList;
        }
    }
};
</script>
